<!-- 
  @desc 侧边单选框组件
  @version version=1.0.0 2019-11-04
  @author yd_zhegnshaobin
-->
<template>
  <el-container
    class="main_panel leftSelect"
    direction="vertical"
    style="border: none;box-shadow: none;border-right: 1px solid #ebebeb;"
  >
    <el-input class="filterText" placeholder="请输入关键字查询" v-model="filterText" size="small"></el-input>
    <div style="overflow: auto;">
      <div class="chooseItem" v-for="(item, index) in chooseData" :key="index">
        <el-radio class="radioItem gl_ellipsis" v-model="radio" :label="item.code" @change="chooseValue">
          {{ item.name }}
        </el-radio>
      </div>
      <div class="noData" v-if="!chooseData.length">暂无数据</div>
    </div>
  </el-container>
</template>
<script>
export default {
  props: { chooseList: Array, orgId: String },
  data() {
    return {
      radio: "",
      filterText: "",
      chooseData: []
    };
  },
  created() {
    this.chooseData = this.chooseList ? this.chooseList : [];
    this.radio = this.orgId ? this.orgId : this.chooseList ? this.chooseList[0].code : "";
    this.chooseValue();
  },
  methods: {
    /* 选择获取值 */
    chooseValue() {
      this.$emit("chooseValue", this.radio);
    }
  },
  watch: {
    chooseList() {
      this.chooseData = this.chooseList;
      this.radio = this.radio ? this.radio : this.chooseList[0].code;
    },
    /* 监听过滤内容 */
    filterText(val) {
      let filterData = [];
      this.chooseList.forEach(item => {
        if (item.name.indexOf(val) !== -1) {
          filterData.push(item);
        }
      });
      this.chooseData = filterData;
    }
  }
};
</script>

<style scoped lang="scss">
.leftSelect {
  /**头部3rem，中间上下padding2.5rem，页面标题5.5rem，页面margin1rem */
  height: calc(100vh - 3rem - 2.5rem - 5.5rem - 1rem);
  padding: 1rem 1rem 1rem 0;
  box-sizing: border-box;
}

.chooseItem {
  line-height: 2rem;
  padding-left: 1rem;
  font-size: 1rem;
}
.radioItem {
  width: 100%;
  font-size: 1rem;
}
.filterText {
  margin-bottom: 1rem;
}
.noData {
  padding: 30% 0;
  text-align: center;
  font-size: 12px;
  color: #909399;
}
</style>
